import gapiService from '@/services/gapi.service';
import microsoftService from '@/services/microsoft.service';
import { Alert, Box, Button, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function CalendarsEmpty() {
	const { t } = useTranslation();
	function handleSyncMicrosoft() {
		microsoftService.syncCalendars();
	}

	function handleSyncGoogle() {
		gapiService.syncCalendars();
	}

	return (
		<Box>
			<Alert status="warning" fontSize="xs" p="4">
				{t('There are no calendars synced to this booking page.')}
			</Alert>

			<Alert status="warning" fontSize="xs" mb="4" px="4" pb="4">
				{t(
					'You can connect your Google and Microsoft calendars to check availability and create events on them directly.'
				)}
			</Alert>

			<VStack mt="4">
				<Button size="sm" textAlign="center" w="100%" colorScheme="blue" type="button" onClick={handleSyncGoogle}>
					{t('Sync Google calendar')}
				</Button>

				<Button
					size="sm"
					textAlign="center"
					w="100%"
					mt="2"
					colorScheme="blue"
					type="button"
					onClick={handleSyncMicrosoft}
				>
					{t('Sync Microsoft calendar')}
				</Button>
			</VStack>
		</Box>
	);
}
